import styled from 'styled-components'
import { orange } from '../../../styles/colors'

export const Section = styled.section`
  background-color: ${orange.argila};
  
  h2 {
    span {
      font-family: 'Citrina', Helvetica, sans-serif;
    }
  }
`
